/**
 * Módulo: Ticker
 * Marquee contínuo e suave usando requestAnimationFrame.
 * Clona os itens até preencher o viewport + sobra, depois
 * desloca pixel a pixel e reseta sem flick.
 */

export function initTicker() {
  const tickers = document.querySelectorAll('.ticker__track-wrapper');

  if (!tickers.length) return;

  tickers.forEach(wrapper => {
    const track = wrapper.querySelector('.ticker__track');
    if (!track) return;

    // Velocidade em px/frame (~60fps → ~0.4px/frame ≈ 24px/s)
    const speed = 0.4;
    let offset = 0;
    let contentWidth = 0;

    function cloneItems() {
      // Mede largura do conteúdo original
      const items = Array.from(track.children);
      contentWidth = items.reduce((sum, el) => sum + el.offsetWidth, 0);

      // Clona itens suficientes para cobrir 2x a largura do wrapper
      const wrapperWidth = wrapper.offsetWidth;
      const clonesNeeded = Math.ceil((wrapperWidth * 2) / contentWidth) + 1;

      for (let i = 0; i < clonesNeeded; i++) {
        items.forEach(item => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        });
      }
    }

    function animate() {
      offset += speed;

      // Quando deslocou a largura do conteúdo original, reseta sem flick
      if (offset >= contentWidth) {
        offset -= contentWidth;
      }

      track.style.transform = `translate3d(-${offset}px, 0, 0)`;
      requestAnimationFrame(animate);
    }

    // Remove a animação CSS (agora é via JS)
    track.style.animation = 'none';

    cloneItems();
    requestAnimationFrame(animate);

    // Recalcular em resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // Remove clones
        const originals = track.querySelectorAll('.ticker__item:not([aria-hidden])');
        track.querySelectorAll('[aria-hidden="true"]').forEach(el => el.remove());
        cloneItems();
      }, 200);
    });
  });
}
